<template>
  <div class="project-user-list-container">
    <el-breadcrumb class="breadcrumb" separator="/">
      <el-breadcrumb-item :to="{ path: '/project' }">项目列表</el-breadcrumb-item>
      <el-breadcrumb-item>添加项目</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card :span="6" style="margin-top: 20px;">
      <el-row :span="24">
          <el-button :size="componentSize" type="primary" @click="importFormVisible = true" icon="el-icon-download" title="导入">导入</el-button>
      </el-row>
      <el-table :size="componentSize" ref="multipleTable" :data="page.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%;"
                border v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" @selection-change="selectionChange">
        <el-table-column prop="name" type="index" label="序号">
          <template slot-scope="scope">
            <div>{{scope.$index + 1}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="用户"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" style="margin-top: 20px;text-align: right;"
                     :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber"
                     @size-change="sizeChange" @current-change="currentChange" >
      </el-pagination>
    </el-card>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" :close-on-click-modal="false" left>
      <el-row>
        <el-col :span="4">
          <el-upload
            class="avatar-uploader"
            :action="fileAction"
            :show-file-list="false"
            :on-success="handleSuccess"
            :before-upload="beforeUpload">
            <el-button :size="componentSize" size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
          </el-upload>
        </el-col>
        <el-col :span="4">
          <el-button style="margin-left: 10px" size="small" type="primary" @click="downloadFile">下载模板</el-button>
        </el-col>
      </el-row>
      <el-table v-loading="importLoading" element-loading-text="正在导入，请不要重复点击导入按钮。。。"
                :size="componentSize" ref="multipleTable" :data="importForm.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%;"
                border>
        <el-table-column prop="name" type="index" label="序号">
          <template slot-scope="scope">
            <div>{{scope.$index + 1}}</div>
          </template>
       </el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="account" label="账号"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button :size="componentSize" type="primary" @click="importData" icon="el-icon-document">导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'projectUserList',
  data() {
    return {
      importLoading: false,
      fileAction: `${process.env.BASE_URL}/userProject/uploadFile`,
      tableLoading: false,
      blockAddUserProject: false,
      blockEditUserProject: false,
      blockDeleteUserProject: false,
      blockBatchDeleteUserProject: false,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: 'id',
        sortOrder: 'asc'
      },
      componentSize: '',
      addFormDialogWidth: '',
      detailFormDialogWidth: '',
      editFormDialogWidth: '',
      addFormVisible: false,
      detailFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        userId: null,
        projectId: null,
      },
      addForm: {
        id: null,
        userId: null,
        projectId: null,
        createTime: null,
        operatorId: null,
        state: null,
      },
      detailForm: {
        id: null,
        userId: null,
        projectId: null,
        createTime: null,
        operatorId: null,
        state: null,
      },
      editForm: {
        id: null,
        userId: null,
        projectId: null,
        createTime: null,
        operatorId: null,
        state: null,
      },
      importForm: {},
      searchFormLabelWidth: '0px',
      formLabelWidth: '80px',
      selection: '',
      multipleSelection: '',
      ids: [],
      rangePickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      fileList: [],
      loading: false,
      permissions: []
    }
  },
  methods: {
    setComponentSize() {
      if(document.body.clientWidth <= 992) {
        this.componentSize = 'mini'
        return
      }
      if(document.body.clientWidth <= 1200) {
        this.componentSize = 'small'
        return
      }
      if(document.body.clientWidth <= 1920) {
        this.componentSize = 'medium'
        return
      }
    },
    setDialogWidth() {
      if(document.body.clientWidth > 1366) {
        this.addFormDialogWidth = '30%'
      }else {
        this.addFormDialogWidth = '40%'
      }
      if(document.body.clientWidth > 1366) {
        this.detailFormDialogWidth = '40%'
      }else {
        this.detailFormDialogWidth = '50%'
      }
      if(document.body.clientWidth > 1366) {
        this.editFormDialogWidth = '30%'
      }else {
        this.editFormDialogWidth = '40%'
      }
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.pageList()
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber
      this.pageList()
    },
    selectionChange(val) {
      this.multipleSelection = val
      this.ids = []
      val.forEach(e => this.ids.push({id: e.id}))
    },
    getUserProjectDetail() {
      this.api.userProject.getUserProjectDetail({
        id: this.selection
      }).then(result => {
        if(result.success) {
          this.detailForm = result.data
        }else {
          this.$message.error(result.message)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getUserProjectById() {
      this.api.userProject.getUserProjectById(this.selection)
        .then(result => {
          if(result.success) {
            this.editForm = result.data
          }else {
            this.$message.error(result.message)
          }
        }).catch(error => {
        console.log(error)
      })
    },
    pageList() {
      this.tableLoading = true
      this.searchForm.pageSize = this.page.pageSize
      this.searchForm.pageNumber = this.page.pageNumber
      this.searchForm.sortName = this.page.sortName
      this.searchForm.sortOrder = this.page.sortOrder
      this.searchForm.projectId = this.$route.query.projectId
      this.api.userProject.pageList(this.searchForm).then(result => {
        this.page.rows = result.data.records
        this.page.total = result.data.total
        this.tableLoading = false
      }).catch(error => {
        console.log(error)
      })
    },
    addUserProject() {
      if(this.blockAddUserProject) {
        return false
      }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.blockAddUserProject = true
          this.api.userProject.addUserProject(this.addForm).then(result => {
            if (result.success) {
              this.$message.success(result.message)
              this.addFormVisible = false
            }else {
              this.$message.error(result.message)
            }
            this.blockAddUserProject = false
          }).catch(error => {
            this.blockAddUserProject = false
            console.log(error)
          })
        } else {
          return false
        }
      })
    },
    updateUserProject() {
      if(this.blockEditUserProject) {
        return false
      }
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.blockEditUserProject = true
          this.api.userProject.updateUserProject(this.editForm).then(result => {
            if(result.success) {
              this.$message.success(result.message)
              this.editFormVisible = false
              this.pageList()
            }else {
              this.$message.error(result.message)
            }
            this.blockEditUserProject = false
          }).catch(error => {
            this.blockEditUserProject = false
            console.log(error)
          })
        } else {
          return false
        }
      })
    },
    deleteUserProject(row) {
      if(this.blockDeleteUserProject) {
        return false
      }
      this.$confirm('您确定要进行删除操作吗？', '系统消息', {
        type: 'warning'
      }).then(()=> {
        this.blockDeleteUserProject = true
        this.api.userProject.deleteUserProject([{
          id: row.id
        }]).then(result => {
          if(result.success) {
            this.$message.success(result.message)
            this.pageList()
          }else {
            this.$message.error(result.message)
          }
          this.blockDeleteUserProject = false
        }).catch(error => {
          this.blockDeleteUserProject = false
          console.log(error)
        })
      }).catch(() => {

      })
    },
    batchDeleteUserProject() {
      if(this.blockBatchDeleteUserProject) {
        return false
      }
      if(this.ids.length === 0) {
        this.$message.error('请选择要删除的数据！')
        return false
      }
      this.$confirm('您确定要进行删除操作吗？', '系统消息', {
        type: 'warning'
      }).then(()=> {
        this.blockBatchDeleteUserProject = true
        this.api.userProject.deleteUserProject(this.ids).then(result => {
          if(result.success) {
            this.$message.success(result.message)
            this.pageList()
          }else {
            this.$message.error(result.message)
          }
          this.blockBatchDeleteUserProject = false
        }).catch(error => {
          this.blockBatchDeleteUserProject = false
          console.log(error)
        })
      }).catch(() => {

      })
    },
    reset() {
      this.$refs.searchForm.resetFields()
      this.pageList()
    },
    handleSuccess (res, file) {
      this.importForm.rows = res.data.rows;
      this.$forceUpdate();
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 1024kb!");
      }
      return isLt2M;
    },
    downloadFile() {
      const url = "../static/file/学习项目人员导入.xlsx";
      window.open(url);
    },
    exportExcel() {
      this.loading = true
      this.api.userProject.exportExcel(this.searchForm).then(result => {
        location.href = result.data
        this.loading = false
      }).catch(error => {
        console.log(error)
      })
    },
    importData() {
      if(!this.$route.query.projectId) {
        this.$message.error('项目id不存在')
        return
      }
      if(this.importLoading) {
        return
      }
      this.importForm.rows.forEach(e => e.projectId = this.$route.query.projectId)
      this.importLoading = true
      this.api.userProject.importData(this.importForm.rows).then(result => {
        if(result.success) {
          this.$message.success(result.message)
          this.importFormVisible = false
          this.importForm.rows = []
          this.pageList();
        }else {
          this.$message.error(result.message)
        }
        this.importLoading = false
      }).catch(error => {
        this.importLoading = false
        console.log(error)
      })
    },
    active(row) {
      this.api.userProject.active(row).then(result => {
        if(result.success) {
          this.$message.success(result.message)
        }else {
          this.$message.error(result.message)
        }
        this.pageList()
      }).catch(error => {
        console.log(error)
      })
    },
    getPermissionList() {
      let user = JSON.parse(localStorage.user)
      user.resources.forEach(e => {
        e.resources.forEach(a => {
          a.resources.forEach(x => this.permissions.push(x.url))
        })
      })
    },
    upload(file) {
      this.api.upload.stsToken().then(result => {
        if(!result.success) {
          this.$message.error(result.message)
        }
        if (file.file.size / 1024 / 1024 > 1) {
          this.$message.error("图片大小不能超过1M");
        } else {
          this.api.upload.uploadOSS(file, result.data, 'userProject').then(result => {

          })
        }
      })
    }
  },
  watch: {
    'addFormVisible': function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields()
        this.pageList()
      } else {
      }
    },
    'detailFormVisible': function (newVal) {
      if (newVal) {
        let loading = this.$loading.service({
          text: '请稍等',
          target: document.querySelector('.detail-form-dialog')
        })
        this.getUserProjectDetail()
        loading.close()
      }
    },
    'editFormVisible': function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields()
        this.pageList()
      } else {
        let loading = this.$loading.service({
          text: '请稍等',
          target: document.querySelector('.edit-form-dialog')
        })
        this.getUserProjectById()
        loading.close()
      }
    }
  },
  mounted() {
    this.setComponentSize()
    this.setDialogWidth()
    this.pageList()
  }
}
</script>

<style lang="less" scoped>
.project-user-list-container {

  .breadcrumb {
    margin: 12px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/project/userList.vue